export default __webpack_public_path__ + "static/media/harry_Goodjob.f9bae295.mp3";